import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core'
import {
  provideRouter,
  withInMemoryScrolling,
  type InMemoryScrollingFeature,
  type InMemoryScrollingOptions,
} from '@angular/router'
import { provideLottieOptions } from 'ngx-lottie'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations'
import { StoreModule, provideStore } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import { routes } from './app.routes'
import { IMAGE_CONFIG } from '@angular/common'
import { rootReducer } from './store'
import { AuthenticationEffects } from './store/authentication/authentication.effects'
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http'
import { FakeBackendProvider } from '@helpers/fake-backend'
import { ErrorInterceptor } from '@helpers/error.interceptor'
import { JwtInterceptor } from '@helpers/jwt.interceptor';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser'
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask'
import { TermlyService } from './services/termly.service'
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { environment } from 'src/environments/environment'


const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};
// Scroll
const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
}

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig)

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideRouter(routes, inMemoryScrollingFeature),
    provideStore(rootReducer),
    provideEffects(AuthenticationEffects),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    FakeBackendProvider,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    BrowserModule,
    BrowserAnimationsModule,
    TermlyService,
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    }, provideClientHydration(),
  ],
}
